import { Geography } from '@rbilabs/common';
import { differenceInMinutes } from 'date-fns';

import { IRestaurant } from '@rbi-ctg/store';
import { useGeolocation } from 'state/geolocation';

interface UserDistanceOptions {
  restaurant: IRestaurant;
  shouldUseUserCoordinatesIfAvailable?: boolean;
}

const MAX_TIME_WITHOUT_UPDATES_IN_MIN = 30;

export const useDistance = ({
  restaurant: { latitude, longitude },
  shouldUseUserCoordinatesIfAvailable = false,
}: UserDistanceOptions) => {
  const { activeCoordinates, userCoordinates, lastUserCoordinateTimestamp } = useGeolocation();
  const lastLocationTimeDiff = differenceInMinutes(
    lastUserCoordinateTimestamp ?? Date.now(),
    Date.now()
  );

  let distance = undefined;
  const coordinates = shouldUseUserCoordinatesIfAvailable
    ? userCoordinates ?? activeCoordinates
    : activeCoordinates;

  if (
    coordinates &&
    coordinates.lat &&
    coordinates.lng &&
    latitude &&
    longitude &&
    lastLocationTimeDiff < MAX_TIME_WITHOUT_UPDATES_IN_MIN
  ) {
    distance = Geography.coordinateDistance(
      { latitude: coordinates.lat, longitude: coordinates.lng },
      {
        latitude,
        longitude,
      }
    );
  }

  return distance;
};
